import { useQuery } from "@tanstack/react-query";
import { fetchDashboardTopGifts } from "@/api/dashboard";

export function useDashboardTopGifts() {
  return useQuery({
    queryKey: ["dashboard", "top-gifts"],
    queryFn: fetchDashboardTopGifts,
    // Redemptions accrue over time — refetch on every navigation into the dashboard.
    refetchOnMount: "always",
  });
}
